export enum ApplicationFormHistoryEventType {
  MODYFIKACJA = 'MODYFIKACJA',
}
